import { Requests } from '@tools/requests';
import {
  URL_XHR_ALGOLIA_OFFERS,
  URL_XHR_ALGOLIA_OFFERS_COUNT,
  URL_XHR_ALGOLIA_SPACES_COUNT,
} from '@tools/routes/routes';
import { Logger } from '@tools/logger/logger';
import { flashBagError } from '@tools/flashbag';
import type { AlgoliaResponse } from '@global-types/algolia';
import type { ExtendedAlgoliaOffer } from '@global-types/algoliaOffer';

export const getAlgoliaOffers = async (): Promise<AlgoliaResponse<ExtendedAlgoliaOffer> | null> => {
  try {
    const response = await Requests.get(URL_XHR_ALGOLIA_OFFERS);

    return response.data;
  } catch (err: unknown) {
    Logger.error(err);
    flashBagError();
  }

  return null;
};

export const getAlgoliaOffersCount = async (): Promise<number | null> => {
  try {
    const response = await Requests.get(URL_XHR_ALGOLIA_OFFERS_COUNT);

    return response.data.count;
  } catch (err: unknown) {
    Logger.error(err);
    flashBagError();
  }

  return null;
};

export const getAlgoliaSpacesCount = async (): Promise<number | null> => {
  try {
    const response = await Requests.get(URL_XHR_ALGOLIA_SPACES_COUNT);

    return response.data.count;
  } catch (err: unknown) {
    Logger.error(err);
    flashBagError();
  }

  return null;
};
